<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Fees Details</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a href="https://wws-schoolerp.s3.ap-south-1.amazonaws.com/documents/UWS_Payment_policy.pdf" style="color: yellow;" target="blank">
                    Payment Policy!!!
                </a>
            </v-toolbar>
            <v-row justify="center">
                <v-tooltip top color="warning">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="red" outlined rounded small class="button" v-bind="attrs" v-on="on" @click="dialog_issue = true"> Amount deducted but receipt not generated. click here</v-btn>
                    </template>
                    <span>
                        Steps to raise dispute.
                    </span>
                </v-tooltip>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="selected_ay"
                        item-value="ay_id"
                        :items="academic_year_list"
                        item-text="academicyear"
                        label="Select Academic Year"
                        outlined
                        @click="show = false"
                    /> 
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-btn class="button ma-0" @click="getDetails()" :loading="proceed_loader">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show_details">
            <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title> Student Details </v-toolbar-title>
            </v-toolbar>
            <v-col cols="12">
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3"><strong>Student : </strong>{{ leaner_name }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ leaner_std }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ leaner_div }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ roll_no }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ quota }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Total Fee : </strong>{{ total_fees }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Paid Fee : </strong>{{ paid_fees }}</v-col>
                    <v-col cols="12" sm="3" md="3"><strong>Remaining Fee : </strong>{{ remaining_fees }}</v-col>
                    <v-col cols="12" sm="3" md="3" align="center" v-if="allow_apply_loan == 'YES' && allowForLoan"><strong>Applicable Loan Amount : </strong>{{ applicable_loan_amt }}</v-col>
                </v-row>
            </v-col>
            <span v-if="is_loan_application_enabled">
                <span v-if="allow_apply_loan == 'YES' && allowForLoan">
                <center><v-btn small class="button"  @click="dailog_apply_loan = true">Apply For Loan</v-btn></center> 
                </span>

                <v-row justify="center" v-if="student_invoice_list==''">
                    <v-btn readonly color="red" outlined rounded small > <strong> If you wish to make an online payment, kindly contact the school admin. </strong></v-btn>
                </v-row>
            </span>
            <span v-else>
              <center><v-btn readonly color="red" outlined rounded small> <strong> Should you wish to apply for a loan, kindly get in touch with the school admin. </strong></v-btn> </center>
              <br>
            </span>
            <v-toolbar class="toolbar" flat dense v-if="student_invoice_list!=''">
                    <v-toolbar-title> Invoice Details </v-toolbar-title>
            </v-toolbar> 
            <v-data-table v-if="student_invoice_list!=''" :items="student_invoice_list" :headers="headers" class="elevation-1 mytable mt-1" dense :search="search">
                <template v-slot:[`item.invoice_number`]="{ item }">
                    <v-tooltip top color="warning">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="getData(item.id)">{{item.invoice_number}}</v-btn>
                        </template>
                        <span>
                            Print Challan!!!
                        </span>
                    </v-tooltip>
                </template>
                <!-- <template v-slot:[`item.pay`]="{ item }">
                    <div v-if="!item.is_paid">
                        <v-tooltip top color="warning">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="pt-none mt-none" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="pay(item)">Pay</v-btn>
                            </template>
                            <span>
                                Pay
                            </span>
                        </v-tooltip>
                    </div>
                    <div v-else class="text">
                        <strong>Already Paid</strong>
                    </div>
                </template> -->
                <template v-slot:[`item.pay`]="{ item }">
                    <div v-if="!item.is_paid">
                        <form :action="url" @submit="payment" name="paytmform" method="POST" v-if="pgs.includes('EaseBuzz')">
                            <input type="hidden" :value="item.org" name="orgid" />
                            <input type="hidden" :value="item.academicyear_id" name="ay"/>
                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                            <input type="hidden" :value="item.uid" name="uid" />
                            <input type="hidden" :value="item.stud_id" name="studid" />
                            <input type="hidden" :value="item.total" name="fee_amount" />
                            <input type="hidden" :value="item.id" name="json_pre_trans_data" />  <!-- learner invoice id -->
                            <input type="hidden" :value="item.hash_val" name="hash_val" />
                            <v-btn small class="button" type="submit" :loading="loader" :disabled="item.pay_fee == 0">Pay Online [EaseBuzz]</v-btn>
                        </form>
                            <form :action="razorpay_url" v-if="pgs.includes('RAZORPAY')" @submit="payment"
                            name="paytmform" method="POST">
                            <input type="hidden" :value="item.org" name="orgid" />
                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                            <input type="hidden" :value="item.uid" name="uid" />
                            <input type="hidden" :value="item.stud_id" name="studid" />
                            <input type="hidden" :value="item.academicyear_id" name="ay" />
                            <input type="hidden" :value="item.total" name="fee_amount" />
                            <input type="hidden" :value="item.id" name="json_pre_trans_data" />
                            <input type="hidden" :value="item.hash_val" name="hash_val" />
                            <input type="hidden" value="INSTALLMENT" name="payment_type" />
                            <v-btn class="button" small :loading="loader" :disabled="item.pay_fee == 0" type="submit">Pay Online
                                [RAZORPAY]</v-btn>
                        </form>
                         <v-btn small class="button" v-if="pgs.includes('CCAVENUE')"
                         @click="initiateInvoiceCCAvenuePayment(item.org,item.academicyear_id,item.tenantid,item.uid,
                         item.stud_id,item.total,item.id,item.hash_val)" 
                         :loading="loader" :disabled="item.pay_fee == 0">Pay Online [CCAVENUE]</v-btn>
                        
                        <!-- <input placeholder="Enter Amount." class="input text-center" type="number" v-model="item.pay_fee" :name="item.pay_fee" :rules="[(v) => !!v || 'Required' || v >= 0]" /> -->
                    </div>
                    <div v-else class="text">
                        <strong>Already Paid</strong>
                    </div>
                </template>
                <template v-slot:[`item.apply_loan`]="{ item }">
                    <span v-if="allow_apply_loan == 'YES' && !item.is_paid">
                        <v-btn small class="button" :disabled="item.pay_fee == 0" @click="apply_loan(item.org,item.academicyear_id,item.tenantid,item.uid,item.stud_id,item.total,item.hash_val,item.id)">Apply For Loan</v-btn>
                    </span>
                    <span v-else>
                        <strong>--</strong>
                    </span>
                </template> 
                <template v-slot:[`item.print`]="{ item }">
                    <span v-if="item.receipt_no">
                        <v-tooltip top color="warning">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="mt-1 mb-1" outlined rounded small color="warning" v-bind="attrs" v-on="on" @click="print_receipt(item.receipt_no, item.academicyear_id,item.registration_number)">
                                    <v-icon color="warning">mdi-printer</v-icon>{{item.receipt_no}}
                                </v-btn>
                            </template>
                            <span> Print Fee Receipt!!! </span>
                        </v-tooltip>
                    </span>
                    <span v-else>--</span>
                </template>
            </v-data-table>
            </span>
            <v-dialog v-model="dialog_challan" style="margin-top: 10%;" max-width="900px">
                <v-card class="mx-auto">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Invoice Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_challan = false"><v-icon>mdi-close</v-icon>Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <br />
                    <v-card-text v-if="learner_challan_data!=''">
                        <div class="main" v-if="learner_challan_data != null" style="border: 1px solid black; max-width: 800px; margin: auto;">
                            <v-col cols="12" sm="12" md="12">
                                <div style="text-align: center; margin-top: -10px;">
                                    <img :src="org_basic_data.trust_logo" width="140px" alt="logo" />
                                </div>
                                <div style="text-align: center; margin-top: -10px;">
                                    Fee Invoice | {{ learner_challan_data.feesinstallmentacademicyear }} | {{ learner_challan_data.ay }}
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense style="margin-top: -15px;">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <td colspan="3" class="text-left" style="border-right: none; border-bottom: none;"><strong>Name : </strong>{{ learner_challan_data.name }}</td>
                                                <td colspan="3" class="text-left" style="border-left: none; border-bottom: none;"><strong>Academic Year :</strong> {{ learner_challan_data.ay }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;">
                                                    <strong>Grade :</strong> {{ learner_challan_data.standard }} ({{ learner_challan_data.quota }})
                                                </td>
                                                <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Invoice Date :</strong> {{ learner_challan_data.invoice_date }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3" class="text-left" style="border-right: none; border-bottom: none; border-top: none;"><strong>Parent's Name :</strong> {{ learner_challan_data.parent_name }}</td>
                                                <td colspan="3" class="text-left" style="border-left: none; border-bottom: none; border-top: none;"><strong>Due Date :</strong> {{ learner_challan_data.due_date }}</td>
                                            </tr>

                                            <tr>
                                                <th style="text-align: center; color: black;">Sr.No</th>
                                                <th style="text-align: center; color: black;">Head</th>
                                                <th style="text-align: center; color: black;">Term Due</th>
                                                <th style="text-align: center; color: black;">Waiver</th>
                                                <th style="text-align: center; color: black;">Due Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in learner_challan_data.student_invoice_details" :key="index">
                                                <td>{{ item.srno }}</td>
                                                <td>{{ item.component }}</td>
                                                <td>{{ item.amount }}</td>
                                                <td>{{ item.waived_amount }}</td>
                                                <td>{{ item.due_amount }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="4" style="text-align: center; font-weight: bolder; text-transform: uppercase;">Total Due Amount</td>
                                                <td>{{ learner_challan_data.total_fees_amount }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                            <div class="main">
                                <v-col cols="12" sm="12" md="12">
                                    <v-simple-table dense>
                                        <template v-slot:default>
                                            <tr>
                                                <td style="text-align: center;"><strong>Amount in words : </strong>{{ learner_challan_data.amount_in_words }}</td>
                                            </tr>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                                <div>
                                <div> <p style="font-size: small; margin-bottom: -0.5px;">
                                <b>Policy :</b><br> 
                                <b>OTHER TERMS AND CONDITIONS :</b> <br> 
                                <b>FEE PAYMENT SCHEDULE </b><br> 
                                Parents are responsible to ensure that the fee is paid by the due date as per the following schedule. </p> 
                                </div>
                            </div>
                            <v-simple-table dense>  
                                <thead>
                                        <tr>
                                            <th style="text-align: center; color: black;">Installment</th>                                                 
                                            <th style="text-align: center; color: black;">Due Date</th>        
                                        </tr>
                                </thead>                                         
                                    <tbody>
                                        <tr v-for="(item, index) in installments_details" :key="index">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.due_date }}</td>                                    
                                        </tr>                                
                                    </tbody>                        
                            </v-simple-table> 
                            </div>
                            <div style="display:flex; padding-left: 17px; margin-top: 5px;">
                    <div style="flex-direction: column;" >
                        <p style="font-size: small;">
                            <b>Payment Mode Options:</b><br>
                            A Cheque/Demand draft may be given in favor of :<br>
                            <b style="text-transform: uppercase;">{{learner_challan_data.in_favour_of}}</b><br>
                            Payment may be done through NEFT/RTGS as per the<br>
                            following bank details. <b> Beneficiary Name:</b><br>
                            <b style="text-transform: uppercase;">{{learner_challan_data.beneficiary_name}}</b><br>
                            <b>Bank Name:</b> {{learner_challan_data.bank_name}}<br>
                            <b>Account Holder Name:</b> {{learner_challan_data.in_favour_of}} <br>
                            <b>Account No.</b> {{learner_challan_data.account_no}}<br>
                            <b>Account Type:</b> {{learner_challan_data.account_type}}<br>
                            <b>IFSC Code:</b> {{learner_challan_data.ifsc_code}}<br>
                            <b>Swift Code (for international transfers):</b> KKBKINBB <br>
                            <b>Branch:</b> {{learner_challan_data.bank_branch}}<br>                              
                        </p>
                    </div>
                    <div style=" border-style: solid; border-width: 3px; padding-top:5px; margin-top:15px; width:35%; text-align:center; margin-left:52px; font-size: medium; height: 35vh;">
                        <b> QR code </b><br>
                        <b> Universal Wisdom School </b><br><br>
                        <div> 
                            <img :src="learner_challan_data.qrcode_path" alt="QR code" width="120" height="120">
                        </div> 
                    </div>
                    <br>
                            </div>
                            <p style="font-size: small; padding-left: 17px;"> 
                                    <b>Please Note:</b><br> 
                                        Fee paid after the due date will attract a late payment penalty at a rate of Rs. 500 per day. NonPayment of Fee for aperiod of 30 days after the due date shall automatically result in cancellation of the student’s name from the class list.
                                        A re-enrollment fee will be charged if the child wishes to continue after cancellation of the enrollment. There will be a penalty of Rs. 1000/- on dishonoured cheques. No withdrawals are permitted in the middle of the term. In case of unavoidable situations where withdrawing the student is imperative,
                                        a notice period of a minimum of 3 months is required to be submitted to the School. No refund can be claimed from the school in case of Mid-Term withdrawal. 
                            </p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dailog_apply_loan" persistent max-width="390">
                <v-card>
                      <center><strong>Are you sure you want to apply for loan?</strong></center>  
                        <center>
                        <v-btn color="green darken-1" text :loading="initiateFeesPaymentLoader" @click="applyForLoan()">
                           Yes
                        </v-btn>
                        <v-btn color="red darken-1" text @click="dailog_apply_loan = false">
                            No
                        </v-btn>
                        </center>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            children: [],
            show: false,
            selected_children: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            url:null,
            academic_year_list:[],
            student_invoice_list: [],
            learner_challan_data: [],
            org_basic_data: null,
            dialog_challan: false,
            selected_ay:null,
            org_id:null,
            installments_details: [],
            leaner_std:null,
            leaner_div:null,
            leaner_name:null,
            quota:null,
            roll_no:null,
            paid_fees:null,
            total_fees:null,
            remaining_fees:null,
            show_details:false,
            allowForLoan:null,
            applicable_loan_amt:null,
            pgs:null,
            comp_id:null,
            student_invoice_info:null,
            headers: [
                { text: "Invoice No", value: "invoice_number", sortable: true, align: "center" },
                { text: "Student", value: "learner", sortable: true, align: "center" },
                { text: "Invoice Date", value: "invoice_date", sortable: true, align: "center" },
                { text: "Installment", value: "feesinstallmentacademicyear", sortable: true, align: "center" },
                { text: "Amount", value: "total", sortable: true, align: "center" },
                { text: "Pay", value: "pay", sortable: true, align: "center" },
               // { text: "Apply For Loan", value: "apply_loan", sortable: true },
                { text: "Print Receipt", value: "print", sortable: true, align: "center" },
            ],
            initiateFeesPaymentLoader:false,
            allow_apply_loan:null,
            is_loan_application_enabled:null,
            razorpay_url:null,
            dailog_apply_loan:false,
            proceed_loader: false
        }),
        created() {
            this.url = process.env.VUE_APP_API_URL + "/PaymentGatewayEaseBuzz/easebuzzinvoicepayment";
            this.razorpay_url = process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate"
        },
        methods: {
            async applyForLoan(){
                 const data = {
                    child: this.selected_children.id,
                    ay: this.selected_ay,
                    comp_id:this.comp_id
                };
                try {
                    const res = await axios.post("/GenerateChallan/apply_for_loan", data);
                    if (res.data.flag == "YES") {
                       this.student_invoice_info = res.data.student_invoice_list
                       if(this.student_invoice_info){
                            this.apply_loan(this.student_invoice_info.org,this.student_invoice_info.academicyear_id,
                                            this.student_invoice_info.tenantid,
                                            this.student_invoice_info.uid,this.student_invoice_info.stud_id,
                                            this.student_invoice_info.total,this.student_invoice_info.hash_val,
                                            this.student_invoice_info.id)
                       }
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                } catch (err) {
                    this.showSnackbar("red", "Something Went Wrong !!!");
                } finally {
                }
            },
            async initiateInvoiceCCAvenuePayment(org,academicyear_id,tenantid,uid,stud_id,total,id,hash_val){
                let formData = new FormData();
                formData.append("orgid", org);
                formData.append("tenantid", tenantid);
                formData.append("ay", academicyear_id);
                formData.append("uid", uid);
                formData.append("studid", stud_id);
                formData.append("fee_amount", total);
                formData.append("json_pre_trans_data", id);
                formData.append("hash_val", hash_val);
                formData.append("payment_type", "INSTALLMENT");
                formData.append("purpose", "INVOICE Fees");
                axios
                  .post("/paymentGatewayCCAvenue/initiateInvoiceCCAvenuePayment", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                        var actionurl = res.data.redirection;
                        var access_code = res.data.merchant_key;
                        var encRequest = res.data.txnToken;
                        if (actionurl && encRequest && access_code) {
                            this.ccavenueRedirection(actionurl, encRequest, access_code);
                        }
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                      this.loader = false;
                      })
                  .catch((error) => {
                      console.log(error);
                      this.loader = false;
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  });
            },
            ccavenueRedirection(actionurl, token, access_code) {
              var form = document.createElement("form");
              var encRequest = document.createElement("input");
              var access_codes = document.createElement("input");

              form.method = "POST";
              form.id = "nomsemless";
              form.action = actionurl;

              encRequest.value = token;
              encRequest.name = "encRequest";
              encRequest.id = "encRequest";
              encRequest.type = "hidden";
              form.appendChild(encRequest);

              access_codes.value = access_code;
              access_codes.name = "access_code";
              access_codes.id = "access_code";
              access_codes.type = "hidden";
              form.appendChild(access_codes);

              document.body.appendChild(form);
              document.getElementById("nomsemless").style.display = "none";
              form.submit();
            },
            async apply_loan(org,academicyear_id,tenantid,uid,stud_id,fee_amount,hash_val,json_pre_trans_data){
                const data ={
                    ay:academicyear_id,
                    orgid:org,
                    studid:stud_id,
                    uid:uid,
                    fee_amount:fee_amount,
                    tenantid:tenantid,
                    hash_val:hash_val,
                    json_pre_trans_data:json_pre_trans_data
                }
                this.initiateFeesPaymentLoader = true;
                axios
                  .post("/payementGatewayzGrayQuest/grayQuestIntiatePayment", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                        console.log("res.data.gray_url:::::"+res.data.gray_url)
                        this.loadGQERPSDK(res.data.gray_url);
                              setTimeout(function () {
                                  //your code here
                              }, 3000);
                              this.initializeGqErpSDK(res.data.referenceNumber,
                               res.data.totalFeesDue,
                               res.data.gray_clientId, res.data.gray_client_secret, 
                               res.data.gray_api_key, res.data.online_payment_account_no,
                               res.data.org_logo,tenantid,res.data.order_id,fee_amount);
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                      this.initiateFeesPaymentLoader = false;
                  })
                  .catch((error) => {
                      console.log(error);
                      this.initiateFeesPaymentLoader = false;
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  });
                
            },
            sleep(ms) {
              return new Promise((resolve) => setTimeout(resolve, ms));
            },
            async initializeGqErpSDK(referenceNumber, 
            totalFeesDue, gray_clientId, gray_client_secret,
            gray_api_key, online_payment_account_no, org_logo,tenantid,order_id,fee_amount) {
                this.initiateFeesPaymentLoader = true;
                if (!window.GqErpSDK) {
                    await this.sleep(5000); // 5000 milliseconds = 5 seconds
                    console.log("after sleep");
                    await this.initializeGqErpSDK(referenceNumber, totalFeesDue, gray_clientId, gray_client_secret, gray_api_key, online_payment_account_no, org_logo,tenantid,order_id,fee_amount);
                    return;
                }
                console.log("in else");
                window.GqErpSDK.setOptions({
                    //   env: "staging",
                    env: "live",
                    auth: {
                        client_id: gray_clientId,
                        client_secret: gray_client_secret,
                        api_key: gray_api_key,
                    },
                    student_id: this.selected_children.registration_number, //3123026010023
                    customer_mobile: this.selected_children.mobile,
                    reference_id: referenceNumber,
                    student_details: {
                        student_first_name: this.selected_children.fname,
                        student_middle_name: this.selected_children.middlename,
                        student_last_name: this.selected_children.lname,
                    },
                    pp_config: {
                        //  slug: "eduplus-pune",
                        slug: online_payment_account_no,
                    },
                    fee_headers: {
                        total_payable: totalFeesDue,
                    },

                    customizations: {
                        logo_url: org_logo,
                        theme: {
                            theme_color: "#292DC2",
                        },
                    },
                    notes: {
                        learnerdetail: this.selected_children.id,
                        email: this.selected_children.email,
                        tenantid:tenantid,
                        order_id:order_id,
                        fee_amount:fee_amount
                    },
                });
                this.initiateFeesPaymentLoader = false;
                window.GqErpSDK.render();
            },
            loadGQERPSDK(url) {
                const scriptId = "gqerp-jssdk";
                console.log("scriptId::::::::"+scriptId)
                if (document.getElementById(scriptId)) return;
                console.log("after  scriptId::::::::"+scriptId)
                const script = document.createElement("script");
                script.id = scriptId;
                script.async = true;
                script.type = "text/javascript";
                script.src = url;
                console.log("GQERP SDK Loaded!!!!"+url);
                document.getElementsByTagName("head")[0].appendChild(script);
                script.onload = () => {
                    console.log("GQERP SDK Loaded!");
                    if (window.GQERP) {
                        window.GQERP.initialize();
                    }
                };
                script.onerror = () => {
                    console.error("Failed to load GQERP SDK.");
                };
            },
            payment() {
                var formData = new FormData(paytmform);
                console.log("formData");
                console.log(formData);
                this.loader = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            print_receipt(receipt_no, ay,registration_number) {
                this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(registration_number));
                // this.$router.push({
                //     name: "student-fees-receipts",
                // });

                // alert(this.org_id)
                if (this.org_id == "zeal") {
                    let routeData = this.$router.resolve({ name: "zeal-student-receipt" });
                    window.open(routeData.href, "_blank");
                } else if (this.org_id == "wws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-wws",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "uwws") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-uwws",
                    });
                    window.open(routeData.href, "_blank");
                }
                 else if (this.org_id == "vvp") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-vvp",
                    });
                    window.open(routeData.href, "_blank");
                }
                else if (this.org_id == "sanjivani") {
                    let routeData = this.$router.resolve({
                        name: "student-fees-receipts-sanjivani",
                    });
                    window.open(routeData.href, "_blank");
                }
                 else {
                    let routeData = this.$router.resolve({ name: "student-fees-receipts" });
                    window.open(routeData.href, "_blank");
                }
            },
            getData(challan_no) {
                this.learner_challan_data = null;
                const formData = {
                    challan_no: challan_no,
                    registration_no: this.selected_children.id,
                    ay: this.selected_ay,
                };
                axios
                    .post("/GenerateChallan/getStudentFeesInvoice", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_challan_data = res.data.student_challan_details;
                            this.org_basic_data = res.data.org_basic_data;
                            this.installments_details = res.data.installments_details;
                            this.dialog_challan = true;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            return;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("red", "Something Went Wrong !!!");
                    })
                    .finally(() => {});
            },
            async getDetails() {
                this.show_details = false
                const data = {
                    child: this.selected_children.id,
                    ay: this.selected_ay,
                };
                this.proceed_loader = true;
                try {
                    const res = await axios.post("/GenerateChallan/getLearnerInvoiceInfo", data);
                    if (res.data.flag == "YES") {
                        this.student_invoice_list = res.data.student_invoice_list;
                        this.allow_apply_loan = res.data.allow_apply_loan
                        this.is_loan_application_enabled = res.data.is_loan_application_enabled
                        this.leaner_std = res.data.leaner_std
                        this.leaner_div = res.data.leaner_div
                        this.leaner_name = res.data.leaner_name
                        this.quota = res.data.quota
                        this.roll_no = res.data.roll_no
                        this.paid_fees = res.data.paid_fees
                        this.total_fees = res.data.total_fees
                        this.remaining_fees = res.data.remaining_fees
                        this.allowForLoan = res.data.allowForLoan
                        this.applicable_loan_amt = res.data.applicable_loan_amt
                        this.pgs = res.data.pgs
                        this.comp_id = res.data.comp_id
                        this.proceed_loader = false;
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("red", res.data.fmsg);
                        this.proceed_loader = false;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.proceed_loader = false;
                    }
                    this.show_details = true
                } catch (err) {
                    this.showSnackbar("red", "Something Went Wrong !!!");
                } finally {
                    this.proceed_loader = false;
                }
            },
        },
        mounted() {
             this.org_id = localStorage.getItem("EPS-tenant");
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                            this.academic_year_list = res.data.academicyearlist;
                            this.selected_ay = res.data.current_ay;
                            this.selected_children = this.children[0];
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
    };
</script>

<style scoped>
.main {
    padding-left: 20px;
    padding-right: 20px;
    color: black;
}
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    tr,
    td,
    th {
        border: 1px solid black;
        text-align: center;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
</style>
